import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FileHelperService {

	constructor() { }

	getFilenameFromPath(filepath: string, removeExtension: boolean = true): string {
		const filename = filepath.replace(/^.*(\\|\/|\:)/, '');
		if (!removeExtension) {
			return filename;
		}

		return this.removeExtension(filename);
	}

	removeExtension(filename: string): string {
		return filename.split('.').slice(0, -1).join('.');
	}

	getExtension(filename: string): string {
		return '.' + filename.split('.').pop();
	}

	convertToFormData(file: File, filename?: string): FormData {
		const formData = new FormData();

		if (filename) {
			formData.append('file', file, filename);
		} else {
			formData.append('file', file, file.name);
		}

		return formData;
	}
}
